export const FETCH_GROWTH_PLAN_COMPANY_DETAILS_REQUEST =
  "FETCH_GROWTH_PLAN_COMPANY_DETAILS_REQUEST";
export const FETCH_GROWTH_PLAN_COMPANY_DETAILS_SUCCESS =
  "FETCH_GROWTH_PLAN_COMPANY_DETAILS_SUCCESS";
export const FETCH_GROWTH_PLAN_COMPANY_DETAILS_FAILURE =
  "FETCH_GROWTH_PLAN_COMPANY_DETAILS_FAILURE";

export const SUBMIT_GOALS_DETAILS_REQUEST = "SUBMIT_GOALS_DETAILS_REQUEST";
export const SUBMIT_GOALS_DETAILS_SUCCESS = "SUBMIT_GOALS_DETAILS_SUCCESS";
export const SUBMIT_GOALS_DETAILS_FAILURE = "SUBMIT_GOALS_DETAILS_FAILURE";

export const CONFIRM_GOALS_DETAILS_REQUEST = "CONFIRM_GOALS_DETAILS_REQUEST";
export const CONFIRM_GOALS_DETAILS_SUCCESS = "CONFIRM_GOALS_DETAILS_SUCCESS";
export const CONFIRM_GOALS_DETAILS_FAILURE = "CONFIRM_GOALS_DETAILS_FAILURE";

export const RESET_GROWTH_PLAN_ASSESSMENT = "RESET_GROWTH_PLAN_ASSESSMENT";

export const FETCH_GROWTH_PLAN_ASSESSMENT_LIST_REQUEST =
  "FETCH_GROWTH_PLAN_ASSESSMENT_LIST_REQUEST";
export const FETCH_GROWTH_PLAN_ASSESSMENT_LIST_SUCCESS =
  "FETCH_GROWTH_PLAN_ASSESSMENT_LIST_SUCCESS";
export const FETCH_GROWTH_PLAN_ASSESSMENT_LIST_FAILURE =
  "FETCH_GROWTH_PLAN_ASSESSMENT_LIST_FAILURE";

export const MARK_AND_UPDATE_GROWTH_PLAN_ASSESSMENT = "MARK_AND_UPDATE_GROWTH_PLAN_ASSESSMENT";

export const FETCH_GOALS_LIST = "FETCH_GOALS_LIST";
